import {
  GET_PENDING_APPOINTMENTS_LIST,
  GET_PENDING_APPOINTMENTS_LIST_SUCCESS,
  GET_PENDING_APPOINTMENTS_LIST_FAILURE,
} from 'store//pendingAppointments/pendingAppointmentListAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getPendingAppointmentsListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PENDING_APPOINTMENTS_LIST:
      return { ...state, loading: true };
    case GET_PENDING_APPOINTMENTS_LIST_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_PENDING_APPOINTMENTS_LIST_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getPendingAppointmentsListReducer;
